import styled, { css } from "styled-components";

import { IGroup } from "pages/[tenant]/g/@types";

import { VideoPlayerContainer } from "shared/components/atoms/VideoPlayer/styles";

const buttonsStyles = css`
  padding: 0.75rem 1.5rem;
  display: flex;
  width: fit-content;
  border-radius: 8px;
  font-size: 0;

  max-height: 42px;
`;

export const SeeMoreButton = styled.div`
  ${buttonsStyles}

  background-color: #ACACAC4D;

  color: #fff;
  text-transform: uppercase;

  transition: 0.3s all;

  font: 700 0.875rem/1.1125rem "Inter";

  :hover {
    cursor: pointer;

    color: #050505;
    background-color: #ffffff;
  }
`;

export const PlayButton = styled.div`
  ${buttonsStyles}

  background-color: rgba(255, 255, 255, 0.8) !important;

  &,
  svg path {
    transition: 0.3s all;
  }

  svg path {
    fill: #050505;
    stroke: #050505;
  }

  :hover {
    cursor: pointer;

    background-color: rgba(255, 255, 255, 1) !important;
  }
`;

interface IBackgroudPlayerContainerProps {
  backgroundContent: string;
  group: IGroup;
  hasSound: boolean;
}

export const BackgroudPlayerContainer = styled.div<IBackgroudPlayerContainerProps>`
  --height-aspect-ratio: 16 / 9;
  min-height: 500px;
  overflow: hidden;
  position: relative;

  :has(${VideoPlayerContainer}) {
    grid-template-areas: "content";
    display: grid;

    .content,
    ${VideoPlayerContainer}, .background-image {
      grid-area: content;
    }
  }

  .content {
    position: relative;
    width: 100%;
    height: 100%;

    display: flex;

    .info-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      position: relative;

      .buttons-container {
        margin-top: 1rem;
        display: flex;
        gap: 0.75rem;
      }

      @media (max-width: 768px) {
        .buttons-container {
          display: none;
        }
      }
    }
  }

  @media (min-width: 768px) {
    .background-image {
      opacity: ${({ backgroundContent }) =>
        backgroundContent === "video" ? "0" : "1"};
      transition: 0.3s all;
    }
  }

  @media (max-width: 768px) {
    overflow: initial;

    .content {
      position: initial;
    }
  }

  @media (max-width: 1000px) {
    display: flex;
    align-items: flex-end;
  }

  aspect-ratio: var(--height-aspect-ratio);
  background-color: #010101;
  position: relative;
  z-index: 1;
  width: inherit;

  .alice-carousel > div,
  .alice-carousel__wrapper {
    height: 100%;
    width: 100vw;
  }

  .background-image,
  #panda-player {
    height: 100%;
    left: 0;
    position: absolute;
    transition: opacity 300ms ease-in-out;
    top: 0;
    width: inherit;
    z-index: 1;
  }

  img {
    object-fit: cover;
  }

  * {
    border: none;
    outline: none;
  }

  .fallback-group-color-background {
    background-color: ${({ group }) => group?.primary_color};
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
  }

  .billboard-presentation-container {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    margin-bottom: 3rem;
    padding: 0 3.125rem;
    width: 100%;
    z-index: 2;

    .title-image {
      position: relative;
      margin-bottom: 1rem;
      width: 100%;
      height: 100%;
      max-width: 400px;

      min-height: 100px;

      img {
        position: initial !important;
      }
    }

    @media (max-width: 768px) {
      justify-content: center;

      text-align: center;

      .info-container {
        align-items: center;
      }

      .title-image {
        width: calc(100vw - 1rem);
      }

      span {
        text-align: center;
      }

      img {
        padding: 0 2rem;
      }
    }

    span {
      margin: 0 !important;
    }

    h1 {
      @font-face {
        font-family: "Outfit";
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src: url(https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4e6yO4a0Ew.woff2)
          format("woff2");
        unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6,
          U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+2074, U+20AC,
          U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
      }

      color: #f2f2f2 !important;
      text-shadow: 0px 0px 8px #00000066;

      font: 600 3rem/3.75rem "Outfit" !important;

      margin-bottom: 20px;
    }

    .badge {
      color: #f2f2f2;

      text-shadow: 0px 0px 8px #00000066;
      font: 700 15px/1.4063rem "Inter";

      @media (max-width: 1600px) {
        font: 700 0.8125rem/1.2188rem "Inter";
      }

      @media (max-width: 400px) {
        font: 700 0.75rem/1.125rem "Inter";
      }

      text-transform: uppercase;
    }

    .subtitle {
      color: #f2f2f2;
      text-shadow: 0px 0px 8px #00000066;
      font: 500 1.25rem/1.875rem "Inter";

      display: block;

      @media (max-width: 1600px) {
        font: 500 0.875rem/1.3125rem "Inter";
      }

      @media (max-width: 400px) {
        font: 600 16px/24px "Inter";
      }
    }

    h1,
    .subtitle {
      display: -webkit-box;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      max-width: 450px;
    }
  }
`;
